export enum ThirdpartyOrganizationType {
    SingleSelect = 1,
    MultiSelect = 2,
}
